import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import * as Objects from '@core/objects';

import * as fromActions from '@core/store/state/project-related-versions/project-related-versions.actions';
import * as fromState from '@core/store/state/project-related-versions/project-related-versions.state';
import { ProjectRVErrors, ProjectRVStarting } from '@core/store/state/project-related-versions/project-related-versions.state';
import { HttpErrorResponse } from '@angular/common/http';
import { VersionShareItem } from '../../models/version-share.model';

@Injectable({
    providedIn: 'root'
})
export class ProjectRelatedVersionsService {
    constructor(private store: Store<fromState.ProjectRelatedVersions>, private actions$: Actions) {}

    // Dispatchers
    initialice(access: boolean) {
        this.store.dispatch(fromActions.Init({ access }));
    }

    setProject(project: Objects.Request) {
        this.store.dispatch(fromActions.SetProject({ project }));
    }

    loadRelated(project: Objects.Request) {
        this.store.dispatch(fromActions.LoadRelated({ project }));
    }

    loadFeedbacks(versions: Objects.Version[]) {
        this.store.dispatch(fromActions.LoadFeedbacks({ versions }));
    }

    // Basic selectors mapped to exported selectors from the state file
    selectProject(): Observable<Objects.Request | null> {
        return this.store.select(fromState.projectSelector);
    }

    selectFiles(): Observable<Objects.File[]> {
        return this.store.select(fromState.filesSelector);
    }

    selectOriginVersion(): Observable<Objects.Version | null> {
        return this.store.select(fromState.originVersionSelector);
    }

    selectRelatedVersions(): Observable<Objects.RelatedVersions[]> {
        return this.store.select(fromState.relatedVersionsSelector);
    }

    // All feedbacks stored in state
    selectAllFeedbacks(): Observable<VersionShareItem[]> {
        return this.store.select(fromState.relatedVersionsFeedbacksSelector);
    }

    // Feedbacks for a given set of versions (uses selector factory from state)
    selectFeedbacksForVersions(versions: Objects.Version[]): Observable<any[]> {
        return this.store.select(fromState.projectVersionsFeedbacksSelector(versions));
    }

    selectErrors(): Observable<ProjectRVErrors> {
        return this.store.select(fromState.errorsSelector);
    }

    // Errors via selector factory exported from state: key must be one of the state's error keys
    selectErrorByKey(key: keyof ProjectRVErrors): Observable<HttpErrorResponse | null> {
        return this.store.select(fromState.errorSelector(key));
    }
    selectStarting(): Observable<ProjectRVStarting> {
        return this.store.select(fromState.startingSelector);
    }

    selectStartingByKey(key: keyof ProjectRVStarting): Observable<boolean> {
        return this.store.select(fromState.actionStartingSelector(key));
    }

    // Clear / reset state
    clear() {
        this.store.dispatch(fromActions.Clear());
    }
}
